/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AirBookRequestDto } from '../models/air-book-request-dto';
import { AjaxResponseOfFileDto } from '../models/ajax-response-of-file-dto';
import { AjaxResponseOfPagedResultDtoOfTripListDto } from '../models/ajax-response-of-paged-result-dto-of-trip-list-dto';
import { AjaxResponseOfTripDto } from '../models/ajax-response-of-trip-dto';
import { ApprovalProcessFlowDto } from '../models/approval-process-flow-dto';
import { ApprovalRequestInputDto } from '../models/approval-request-input-dto';
import { AuthorizationResponseDto } from '../models/authorization-response-dto';
import { BookTripRequestDto } from '../models/book-trip-request-dto';
import { BookTripResponseDto } from '../models/book-trip-response-dto';
import { CarBookRequestBaseDto } from '../models/car-book-request-base-dto';
import { CheckTripDataForServicesOutputDto } from '../models/check-trip-data-for-services-output-dto';
import { CheckTripDataOutputDto } from '../models/check-trip-data-output-dto';
import { CostDivisionElementDto } from '../models/cost-division-element-dto';
import { CreateTripInput } from '../models/create-trip-input';
import { CustomFieldDto } from '../models/custom-field-dto';
import { FieldConfigDto } from '../models/field-config-dto';
import { FieldConfigInputDto } from '../models/field-config-input-dto';
import { LabelDto } from '../models/label-dto';
import { LogDto } from '../models/log-dto';
import { PagedResultDtoOfTripListDto } from '../models/paged-result-dto-of-trip-list-dto';
import { SaveTripSearchInput } from '../models/save-trip-search-input';
import { TrainBookRequestBaseDto } from '../models/train-book-request-base-dto';
import { TrainBookResponseDto } from '../models/train-book-response-dto';
import { TripDto } from '../models/trip-dto';
import { TripFilterDto } from '../models/trip-filter-dto';
import { TripItemTypeDto } from '../models/trip-item-type-dto';
import { TripStatusDto } from '../models/trip-status-dto';
import { UpdateTravelerInputDto } from '../models/update-traveler-input-dto';
import { UserProfileDto } from '../models/user-profile-dto';

@Injectable({
  providedIn: 'root',
})
export class TripService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getTripById
   */
  static readonly GetTripByIdPath = '/api/services/app/Trip/GetTripById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTripById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTripById$Response(params?: {
    id?: string;
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.GetTripByIdPath, 'get');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTripById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTripById(params?: {
    id?: string;
  }): Observable<TripDto> {

    return this.getTripById$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * Path part for operation getAllUsersTrips
   */
  static readonly GetAllUsersTripsPath = '/api/services/app/Trip/GetAllUsersTrips';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllUsersTrips()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllUsersTrips$Response(params?: {
    TripStatus?: Array<number>;
    'TripDateRange.Start'?: string;
    'TripDateRange.End'?: string;
    'DepartureDateRange.Start'?: string;
    'DepartureDateRange.End'?: string;
    IsTripDateRangeEnabled?: boolean;
    IsDepartureDateRangeEnabled?: boolean;
    TripCode?: string;
    Surname?: string;
    Name?: string;
    Sorting?: string;
    MaxResultCount?: number;
    SkipCount?: number;
  }): Observable<StrictHttpResponse<AjaxResponseOfPagedResultDtoOfTripListDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.GetAllUsersTripsPath, 'get');
    if (params) {
      rb.query('TripStatus', params.TripStatus, {});
      rb.query('TripDateRange.Start', params['TripDateRange.Start'], {});
      rb.query('TripDateRange.End', params['TripDateRange.End'], {});
      rb.query('DepartureDateRange.Start', params['DepartureDateRange.Start'], {});
      rb.query('DepartureDateRange.End', params['DepartureDateRange.End'], {});
      rb.query('IsTripDateRangeEnabled', params.IsTripDateRangeEnabled, {});
      rb.query('IsDepartureDateRangeEnabled', params.IsDepartureDateRangeEnabled, {});
      rb.query('TripCode', params.TripCode, {});
      rb.query('Surname', params.Surname, {});
      rb.query('Name', params.Name, {});
      rb.query('Sorting', params.Sorting, {});
      rb.query('MaxResultCount', params.MaxResultCount, {});
      rb.query('SkipCount', params.SkipCount, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AjaxResponseOfPagedResultDtoOfTripListDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllUsersTrips$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllUsersTrips(params?: {
    TripStatus?: Array<number>;
    'TripDateRange.Start'?: string;
    'TripDateRange.End'?: string;
    'DepartureDateRange.Start'?: string;
    'DepartureDateRange.End'?: string;
    IsTripDateRangeEnabled?: boolean;
    IsDepartureDateRangeEnabled?: boolean;
    TripCode?: string;
    Surname?: string;
    Name?: string;
    Sorting?: string;
    MaxResultCount?: number;
    SkipCount?: number;
  }): Observable<AjaxResponseOfPagedResultDtoOfTripListDto> {

    return this.getAllUsersTrips$Response(params).pipe(
      map((r: StrictHttpResponse<AjaxResponseOfPagedResultDtoOfTripListDto>) => r.body as AjaxResponseOfPagedResultDtoOfTripListDto)
    );
  }

  /**
   * Path part for operation getTripListToExcel
   */
  static readonly GetTripListToExcelPath = '/api/services/app/Trip/GetTripListToExcel';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTripListToExcel()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTripListToExcel$Response(params?: {
    TripStatus?: Array<number>;
    'TripDateRange.Start'?: string;
    'TripDateRange.End'?: string;
    'DepartureDateRange.Start'?: string;
    'DepartureDateRange.End'?: string;
    IsTripDateRangeEnabled?: boolean;
    IsDepartureDateRangeEnabled?: boolean;
    TripCode?: string;
    Surname?: string;
    Name?: string;
    Sorting?: string;
    MaxResultCount?: number;
    SkipCount?: number;
  }): Observable<StrictHttpResponse<AjaxResponseOfFileDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.GetTripListToExcelPath, 'get');
    if (params) {
      rb.query('TripStatus', params.TripStatus, {});
      rb.query('TripDateRange.Start', params['TripDateRange.Start'], {});
      rb.query('TripDateRange.End', params['TripDateRange.End'], {});
      rb.query('DepartureDateRange.Start', params['DepartureDateRange.Start'], {});
      rb.query('DepartureDateRange.End', params['DepartureDateRange.End'], {});
      rb.query('IsTripDateRangeEnabled', params.IsTripDateRangeEnabled, {});
      rb.query('IsDepartureDateRangeEnabled', params.IsDepartureDateRangeEnabled, {});
      rb.query('TripCode', params.TripCode, {});
      rb.query('Surname', params.Surname, {});
      rb.query('Name', params.Name, {});
      rb.query('Sorting', params.Sorting, {});
      rb.query('MaxResultCount', params.MaxResultCount, {});
      rb.query('SkipCount', params.SkipCount, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AjaxResponseOfFileDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTripListToExcel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTripListToExcel(params?: {
    TripStatus?: Array<number>;
    'TripDateRange.Start'?: string;
    'TripDateRange.End'?: string;
    'DepartureDateRange.Start'?: string;
    'DepartureDateRange.End'?: string;
    IsTripDateRangeEnabled?: boolean;
    IsDepartureDateRangeEnabled?: boolean;
    TripCode?: string;
    Surname?: string;
    Name?: string;
    Sorting?: string;
    MaxResultCount?: number;
    SkipCount?: number;
  }): Observable<AjaxResponseOfFileDto> {

    return this.getTripListToExcel$Response(params).pipe(
      map((r: StrictHttpResponse<AjaxResponseOfFileDto>) => r.body as AjaxResponseOfFileDto)
    );
  }

  /**
   * Path part for operation getTripsForUser
   */
  static readonly GetTripsForUserPath = '/api/services/app/Trip/GetTripsForUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTripsForUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTripsForUser$Response(params: {
    TripsFilter: TripFilterDto;
    Sorting?: string;
    MaxResultCount?: number;
    SkipCount?: number;
  }): Observable<StrictHttpResponse<PagedResultDtoOfTripListDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.GetTripsForUserPath, 'get');
    if (params) {
      rb.query('TripsFilter', params.TripsFilter, {});
      rb.query('Sorting', params.Sorting, {});
      rb.query('MaxResultCount', params.MaxResultCount, {});
      rb.query('SkipCount', params.SkipCount, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PagedResultDtoOfTripListDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTripsForUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTripsForUser(params: {
    TripsFilter: TripFilterDto;
    Sorting?: string;
    MaxResultCount?: number;
    SkipCount?: number;
  }): Observable<PagedResultDtoOfTripListDto> {

    return this.getTripsForUser$Response(params).pipe(
      map((r: StrictHttpResponse<PagedResultDtoOfTripListDto>) => r.body as PagedResultDtoOfTripListDto)
    );
  }

  /**
   * Path part for operation discardTrip
   */
  static readonly DiscardTripPath = '/api/services/app/Trip/DiscardTrip';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `discardTrip()` instead.
   *
   * This method doesn't expect any request body.
   */
  discardTrip$Response(params?: {
    id?: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.DiscardTripPath, 'post');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `discardTrip$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  discardTrip(params?: {
    id?: string;
  }): Observable<void> {

    return this.discardTrip$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation deleteTrip
   */
  static readonly DeleteTripPath = '/api/services/app/Trip/DeleteTrip';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTrip()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTrip$Response(params?: {
    id?: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.DeleteTripPath, 'delete');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteTrip$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTrip(params?: {
    id?: string;
  }): Observable<void> {

    return this.deleteTrip$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getLabelAutocomplete
   */
  static readonly GetLabelAutocompletePath = '/api/services/app/Trip/GetLabelAutocomplete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLabelAutocomplete()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLabelAutocomplete$Response(params?: {
    query?: string;
  }): Observable<StrictHttpResponse<Array<LabelDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.GetLabelAutocompletePath, 'get');
    if (params) {
      rb.query('query', params.query, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<LabelDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getLabelAutocomplete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLabelAutocomplete(params?: {
    query?: string;
  }): Observable<Array<LabelDto>> {

    return this.getLabelAutocomplete$Response(params).pipe(
      map((r: StrictHttpResponse<Array<LabelDto>>) => r.body as Array<LabelDto>)
    );
  }

  /**
   * Path part for operation updateTraveler
   */
  static readonly UpdateTravelerPath = '/api/services/app/Trip/UpdateTraveler';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTraveler()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateTraveler$Response(params?: {
    body?: UpdateTravelerInputDto
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.UpdateTravelerPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateTraveler$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateTraveler(params?: {
    body?: UpdateTravelerInputDto
  }): Observable<TripDto> {

    return this.updateTraveler$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTraveler$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  updateTraveler$Xml$Response(params?: {
    body?: UpdateTravelerInputDto
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.UpdateTravelerPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+xml');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateTraveler$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  updateTraveler$Xml(params?: {
    body?: UpdateTravelerInputDto
  }): Observable<TripDto> {

    return this.updateTraveler$Xml$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * Path part for operation setTripName
   */
  static readonly SetTripNamePath = '/api/services/app/Trip/SetTripName';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setTripName()` instead.
   *
   * This method doesn't expect any request body.
   */
  setTripName$Response(params?: {
    tripId?: string;
    tripName?: string;
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.SetTripNamePath, 'post');
    if (params) {
      rb.query('tripId', params.tripId, {});
      rb.query('tripName', params.tripName, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `setTripName$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  setTripName(params?: {
    tripId?: string;
    tripName?: string;
  }): Observable<TripDto> {

    return this.setTripName$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * Path part for operation checkTripData
   */
  static readonly CheckTripDataPath = '/api/services/app/Trip/CheckTripData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `checkTripData()` instead.
   *
   * This method doesn't expect any request body.
   */
  checkTripData$Response(params?: {
    tripId?: string;
  }): Observable<StrictHttpResponse<CheckTripDataOutputDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.CheckTripDataPath, 'post');
    if (params) {
      rb.query('tripId', params.tripId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CheckTripDataOutputDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `checkTripData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  checkTripData(params?: {
    tripId?: string;
  }): Observable<CheckTripDataOutputDto> {

    return this.checkTripData$Response(params).pipe(
      map((r: StrictHttpResponse<CheckTripDataOutputDto>) => r.body as CheckTripDataOutputDto)
    );
  }

  /**
   * Path part for operation checkTripDataForServices
   */
  static readonly CheckTripDataForServicesPath = '/api/services/app/Trip/CheckTripDataForServices';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `checkTripDataForServices()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  checkTripDataForServices$Response(params?: {
    tripId?: string;
    body?: Array<TripItemTypeDto>
  }): Observable<StrictHttpResponse<CheckTripDataForServicesOutputDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.CheckTripDataForServicesPath, 'post');
    if (params) {
      rb.query('tripId', params.tripId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CheckTripDataForServicesOutputDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `checkTripDataForServices$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  checkTripDataForServices(params?: {
    tripId?: string;
    body?: Array<TripItemTypeDto>
  }): Observable<CheckTripDataForServicesOutputDto> {

    return this.checkTripDataForServices$Response(params).pipe(
      map((r: StrictHttpResponse<CheckTripDataForServicesOutputDto>) => r.body as CheckTripDataForServicesOutputDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `checkTripDataForServices$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  checkTripDataForServices$Xml$Response(params?: {
    tripId?: string;
    body?: Array<TripItemTypeDto>
  }): Observable<StrictHttpResponse<CheckTripDataForServicesOutputDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.CheckTripDataForServicesPath, 'post');
    if (params) {
      rb.query('tripId', params.tripId, {});
      rb.body(params.body, 'application/*+xml');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CheckTripDataForServicesOutputDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `checkTripDataForServices$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  checkTripDataForServices$Xml(params?: {
    tripId?: string;
    body?: Array<TripItemTypeDto>
  }): Observable<CheckTripDataForServicesOutputDto> {

    return this.checkTripDataForServices$Xml$Response(params).pipe(
      map((r: StrictHttpResponse<CheckTripDataForServicesOutputDto>) => r.body as CheckTripDataForServicesOutputDto)
    );
  }

  /**
   * Path part for operation getLabels
   */
  static readonly GetLabelsPath = '/api/services/app/Trip/GetLabels';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLabels()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLabels$Response(params?: {
    tripId?: string;
  }): Observable<StrictHttpResponse<Array<string>>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.GetLabelsPath, 'get');
    if (params) {
      rb.query('tripId', params.tripId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getLabels$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLabels(params?: {
    tripId?: string;
  }): Observable<Array<string>> {

    return this.getLabels$Response(params).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

  /**
   * Path part for operation setLabels
   */
  static readonly SetLabelsPath = '/api/services/app/Trip/SetLabels';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setLabels()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setLabels$Response(params?: {
    tripId?: string;
    body?: Array<string>
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.SetLabelsPath, 'post');
    if (params) {
      rb.query('tripId', params.tripId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `setLabels$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setLabels(params?: {
    tripId?: string;
    body?: Array<string>
  }): Observable<TripDto> {

    return this.setLabels$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setLabels$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  setLabels$Xml$Response(params?: {
    tripId?: string;
    body?: Array<string>
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.SetLabelsPath, 'post');
    if (params) {
      rb.query('tripId', params.tripId, {});
      rb.body(params.body, 'application/*+xml');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `setLabels$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  setLabels$Xml(params?: {
    tripId?: string;
    body?: Array<string>
  }): Observable<TripDto> {

    return this.setLabels$Xml$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * Path part for operation crateAssistedTrip
   */
  static readonly CrateAssistedTripPath = '/api/services/app/Trip/CrateAssistedTrip';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `crateAssistedTrip()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  crateAssistedTrip$Response(params?: {
    body?: CreateTripInput
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.CrateAssistedTripPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `crateAssistedTrip$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  crateAssistedTrip(params?: {
    body?: CreateTripInput
  }): Observable<TripDto> {

    return this.crateAssistedTrip$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `crateAssistedTrip$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  crateAssistedTrip$Xml$Response(params?: {
    body?: CreateTripInput
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.CrateAssistedTripPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+xml');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `crateAssistedTrip$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  crateAssistedTrip$Xml(params?: {
    body?: CreateTripInput
  }): Observable<TripDto> {

    return this.crateAssistedTrip$Xml$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * Path part for operation initTrip
   */
  static readonly InitTripPath = '/api/services/app/Trip/InitTrip';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `initTrip()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  initTrip$Response(params?: {
    name?: string;
    hqId?: number;
    cdcId?: number;
    body?: Array<UserProfileDto>
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.InitTripPath, 'post');
    if (params) {
      rb.query('name', params.name, {});
      rb.query('hqId', params.hqId, {});
      rb.query('cdcId', params.cdcId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `initTrip$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  initTrip(params?: {
    name?: string;
    hqId?: number;
    cdcId?: number;
    body?: Array<UserProfileDto>
  }): Observable<TripDto> {

    return this.initTrip$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `initTrip$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  initTrip$Xml$Response(params?: {
    name?: string;
    hqId?: number;
    cdcId?: number;
    body?: Array<UserProfileDto>
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.InitTripPath, 'post');
    if (params) {
      rb.query('name', params.name, {});
      rb.query('hqId', params.hqId, {});
      rb.query('cdcId', params.cdcId, {});
      rb.body(params.body, 'application/*+xml');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `initTrip$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  initTrip$Xml(params?: {
    name?: string;
    hqId?: number;
    cdcId?: number;
    body?: Array<UserProfileDto>
  }): Observable<TripDto> {

    return this.initTrip$Xml$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * Path part for operation addFlightItem
   */
  static readonly AddFlightItemPath = '/api/services/app/Trip/AddFlightItem';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addFlightItem()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addFlightItem$Response(params?: {
    tripId?: string;
    body?: AirBookRequestDto
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.AddFlightItemPath, 'post');
    if (params) {
      rb.query('tripId', params.tripId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `addFlightItem$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addFlightItem(params?: {
    tripId?: string;
    body?: AirBookRequestDto
  }): Observable<TripDto> {

    return this.addFlightItem$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * Path part for operation addHotelItem
   */
  static readonly AddHotelItemPath = '/api/services/app/Trip/AddHotelItem';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addHotelItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  addHotelItem$Response(params?: {
    tripId?: string;
    availabilityDetailId?: string;
    optionId?: string;
    availabilityId?: string;
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.AddHotelItemPath, 'post');
    if (params) {
      rb.query('tripId', params.tripId, {});
      rb.query('availabilityDetailId', params.availabilityDetailId, {});
      rb.query('optionId', params.optionId, {});
      rb.query('availabilityId', params.availabilityId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `addHotelItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  addHotelItem(params?: {
    tripId?: string;
    availabilityDetailId?: string;
    optionId?: string;
    availabilityId?: string;
  }): Observable<TripDto> {

    return this.addHotelItem$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * Path part for operation addTrainItem
   */
  static readonly AddTrainItemPath = '/api/services/app/Trip/AddTrainItem';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addTrainItem()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addTrainItem$Response(params?: {
    tripId?: string;
    body?: TrainBookRequestBaseDto
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.AddTrainItemPath, 'post');
    if (params) {
      rb.query('tripId', params.tripId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `addTrainItem$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addTrainItem(params?: {
    tripId?: string;
    body?: TrainBookRequestBaseDto
  }): Observable<TripDto> {

    return this.addTrainItem$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addTrainItem$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  addTrainItem$Xml$Response(params?: {
    tripId?: string;
    body?: TrainBookRequestBaseDto
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.AddTrainItemPath, 'post');
    if (params) {
      rb.query('tripId', params.tripId, {});
      rb.body(params.body, 'application/*+xml');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `addTrainItem$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  addTrainItem$Xml(params?: {
    tripId?: string;
    body?: TrainBookRequestBaseDto
  }): Observable<TripDto> {

    return this.addTrainItem$Xml$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * Path part for operation addCarItem
   */
  static readonly AddCarItemPath = '/api/services/app/Trip/AddCarItem';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addCarItem()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addCarItem$Response(params?: {
    tripId?: string;
    body?: CarBookRequestBaseDto
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.AddCarItemPath, 'post');
    if (params) {
      rb.query('tripId', params.tripId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `addCarItem$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addCarItem(params?: {
    tripId?: string;
    body?: CarBookRequestBaseDto
  }): Observable<TripDto> {

    return this.addCarItem$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addCarItem$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  addCarItem$Xml$Response(params?: {
    tripId?: string;
    body?: CarBookRequestBaseDto
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.AddCarItemPath, 'post');
    if (params) {
      rb.query('tripId', params.tripId, {});
      rb.body(params.body, 'application/*+xml');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `addCarItem$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  addCarItem$Xml(params?: {
    tripId?: string;
    body?: CarBookRequestBaseDto
  }): Observable<TripDto> {

    return this.addCarItem$Xml$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * Path part for operation removeTripItem
   */
  static readonly RemoveTripItemPath = '/api/services/app/Trip/RemoveTripItem';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeTripItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeTripItem$Response(params?: {
    tripId?: string;
    tripItemId?: string;
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.RemoveTripItemPath, 'delete');
    if (params) {
      rb.query('tripId', params.tripId, {});
      rb.query('tripItemId', params.tripItemId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `removeTripItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeTripItem(params?: {
    tripId?: string;
    tripItemId?: string;
  }): Observable<TripDto> {

    return this.removeTripItem$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * Path part for operation getItineraryData
   */
  static readonly GetItineraryDataPath = '/api/services/app/Trip/GetItineraryData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getItineraryData()` instead.
   *
   * This method doesn't expect any request body.
   */
  getItineraryData$Response(params?: {
    tripId?: string;
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.GetItineraryDataPath, 'get');
    if (params) {
      rb.query('tripId', params.tripId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getItineraryData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getItineraryData(params?: {
    tripId?: string;
  }): Observable<TripDto> {

    return this.getItineraryData$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * Path part for operation saveTripSearch
   */
  static readonly SaveTripSearchPath = '/api/services/app/Trip/SaveTripSearch';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `saveTripSearch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  saveTripSearch$Response(params?: {
    body?: SaveTripSearchInput
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.SaveTripSearchPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `saveTripSearch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  saveTripSearch(params?: {
    body?: SaveTripSearchInput
  }): Observable<TripDto> {

    return this.saveTripSearch$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `saveTripSearch$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  saveTripSearch$Xml$Response(params?: {
    body?: SaveTripSearchInput
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.SaveTripSearchPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+xml');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `saveTripSearch$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  saveTripSearch$Xml(params?: {
    body?: SaveTripSearchInput
  }): Observable<TripDto> {

    return this.saveTripSearch$Xml$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * Path part for operation authorizeTrip
   */
  static readonly AuthorizeTripPath = '/api/services/app/Trip/AuthorizeTrip';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authorizeTrip()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  authorizeTrip$Response(params?: {
    tripId?: string;
    body?: AuthorizationResponseDto
  }): Observable<StrictHttpResponse<AjaxResponseOfTripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.AuthorizeTripPath, 'post');
    if (params) {
      rb.query('tripId', params.tripId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AjaxResponseOfTripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `authorizeTrip$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  authorizeTrip(params?: {
    tripId?: string;
    body?: AuthorizationResponseDto
  }): Observable<AjaxResponseOfTripDto> {

    return this.authorizeTrip$Response(params).pipe(
      map((r: StrictHttpResponse<AjaxResponseOfTripDto>) => r.body as AjaxResponseOfTripDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authorizeTrip$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  authorizeTrip$Xml$Response(params?: {
    tripId?: string;
    body?: AuthorizationResponseDto
  }): Observable<StrictHttpResponse<AjaxResponseOfTripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.AuthorizeTripPath, 'post');
    if (params) {
      rb.query('tripId', params.tripId, {});
      rb.body(params.body, 'application/*+xml');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AjaxResponseOfTripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `authorizeTrip$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  authorizeTrip$Xml(params?: {
    tripId?: string;
    body?: AuthorizationResponseDto
  }): Observable<AjaxResponseOfTripDto> {

    return this.authorizeTrip$Xml$Response(params).pipe(
      map((r: StrictHttpResponse<AjaxResponseOfTripDto>) => r.body as AjaxResponseOfTripDto)
    );
  }

  /**
   * Path part for operation switchTripToAgency
   */
  static readonly SwitchTripToAgencyPath = '/api/services/app/Trip/SwitchTripToAgency';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `switchTripToAgency()` instead.
   *
   * This method doesn't expect any request body.
   */
  switchTripToAgency$Response(params?: {
    tripId?: string;
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.SwitchTripToAgencyPath, 'post');
    if (params) {
      rb.query('tripId', params.tripId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `switchTripToAgency$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  switchTripToAgency(params?: {
    tripId?: string;
  }): Observable<TripDto> {

    return this.switchTripToAgency$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * Path part for operation getCheckoutData_2
   */
  static readonly GetCheckoutData_2Path = '/api/services/app/Trip/GetCheckoutData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCheckoutData_2()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCheckoutData_2$Response(params?: {
    tripId?: string;
  }): Observable<StrictHttpResponse<BookTripResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.GetCheckoutData_2Path, 'get');
    if (params) {
      rb.query('tripId', params.tripId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BookTripResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCheckoutData_2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCheckoutData_2(params?: {
    tripId?: string;
  }): Observable<BookTripResponseDto> {

    return this.getCheckoutData_2$Response(params).pipe(
      map((r: StrictHttpResponse<BookTripResponseDto>) => r.body as BookTripResponseDto)
    );
  }

  /**
   * Path part for operation approvalRequest
   */
  static readonly ApprovalRequestPath = '/api/services/app/Trip/ApprovalRequest';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `approvalRequest()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  approvalRequest$Response(params?: {
    body?: ApprovalRequestInputDto
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.ApprovalRequestPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `approvalRequest$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  approvalRequest(params?: {
    body?: ApprovalRequestInputDto
  }): Observable<TripDto> {

    return this.approvalRequest$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `approvalRequest$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  approvalRequest$Xml$Response(params?: {
    body?: ApprovalRequestInputDto
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.ApprovalRequestPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+xml');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `approvalRequest$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  approvalRequest$Xml(params?: {
    body?: ApprovalRequestInputDto
  }): Observable<TripDto> {

    return this.approvalRequest$Xml$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * Path part for operation startApprovalProcessFlow
   */
  static readonly StartApprovalProcessFlowPath = '/api/services/app/Trip/StartApprovalProcessFlow';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `startApprovalProcessFlow()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  startApprovalProcessFlow$Response(params?: {
    body?: ApprovalRequestInputDto
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.StartApprovalProcessFlowPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `startApprovalProcessFlow$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  startApprovalProcessFlow(params?: {
    body?: ApprovalRequestInputDto
  }): Observable<TripDto> {

    return this.startApprovalProcessFlow$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `startApprovalProcessFlow$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  startApprovalProcessFlow$Xml$Response(params?: {
    body?: ApprovalRequestInputDto
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.StartApprovalProcessFlowPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+xml');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `startApprovalProcessFlow$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  startApprovalProcessFlow$Xml(params?: {
    body?: ApprovalRequestInputDto
  }): Observable<TripDto> {

    return this.startApprovalProcessFlow$Xml$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * Path part for operation approve
   */
  static readonly ApprovePath = '/api/services/app/Trip/Approve';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `approve()` instead.
   *
   * This method doesn't expect any request body.
   */
  approve$Response(params?: {
    tripId?: string;
    message?: string;
    reasonId?: string;
    approvalProcessId?: string;
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.ApprovePath, 'post');
    if (params) {
      rb.query('tripId', params.tripId, {});
      rb.query('message', params.message, {});
      rb.query('reasonId', params.reasonId, {});
      rb.query('approvalProcessId', params.approvalProcessId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `approve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  approve(params?: {
    tripId?: string;
    message?: string;
    reasonId?: string;
    approvalProcessId?: string;
  }): Observable<TripDto> {

    return this.approve$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * Path part for operation decline
   */
  static readonly DeclinePath = '/api/services/app/Trip/Decline';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `decline()` instead.
   *
   * This method doesn't expect any request body.
   */
  decline$Response(params?: {
    tripId?: string;
    message?: string;
    reasonId?: string;
    approvalProcessId?: string;
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.DeclinePath, 'post');
    if (params) {
      rb.query('tripId', params.tripId, {});
      rb.query('message', params.message, {});
      rb.query('reasonId', params.reasonId, {});
      rb.query('approvalProcessId', params.approvalProcessId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `decline$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  decline(params?: {
    tripId?: string;
    message?: string;
    reasonId?: string;
    approvalProcessId?: string;
  }): Observable<TripDto> {

    return this.decline$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * Path part for operation hold
   */
  static readonly HoldPath = '/api/services/app/Trip/Hold';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `hold()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  hold$Response(params?: {
    body?: BookTripRequestDto
  }): Observable<StrictHttpResponse<TrainBookResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.HoldPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TrainBookResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `hold$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  hold(params?: {
    body?: BookTripRequestDto
  }): Observable<TrainBookResponseDto> {

    return this.hold$Response(params).pipe(
      map((r: StrictHttpResponse<TrainBookResponseDto>) => r.body as TrainBookResponseDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `hold$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  hold$Xml$Response(params?: {
    body?: BookTripRequestDto
  }): Observable<StrictHttpResponse<TrainBookResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.HoldPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+xml');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TrainBookResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `hold$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  hold$Xml(params?: {
    body?: BookTripRequestDto
  }): Observable<TrainBookResponseDto> {

    return this.hold$Xml$Response(params).pipe(
      map((r: StrictHttpResponse<TrainBookResponseDto>) => r.body as TrainBookResponseDto)
    );
  }

  /**
   * Path part for operation book_3
   */
  static readonly Book_3Path = '/api/services/app/Trip/Book';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `book_3()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  book_3$Response(params?: {
    body?: BookTripRequestDto
  }): Observable<StrictHttpResponse<AjaxResponseOfTripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.Book_3Path, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AjaxResponseOfTripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `book_3$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  book_3(params?: {
    body?: BookTripRequestDto
  }): Observable<AjaxResponseOfTripDto> {

    return this.book_3$Response(params).pipe(
      map((r: StrictHttpResponse<AjaxResponseOfTripDto>) => r.body as AjaxResponseOfTripDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `book_3$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  book_3$Xml$Response(params?: {
    body?: BookTripRequestDto
  }): Observable<StrictHttpResponse<AjaxResponseOfTripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.Book_3Path, 'post');
    if (params) {
      rb.body(params.body, 'application/*+xml');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AjaxResponseOfTripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `book_3$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  book_3$Xml(params?: {
    body?: BookTripRequestDto
  }): Observable<AjaxResponseOfTripDto> {

    return this.book_3$Xml$Response(params).pipe(
      map((r: StrictHttpResponse<AjaxResponseOfTripDto>) => r.body as AjaxResponseOfTripDto)
    );
  }

  /**
   * Path part for operation issue_4
   */
  static readonly Issue_4Path = '/api/services/app/Trip/Issue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `issue_4()` instead.
   *
   * This method doesn't expect any request body.
   */
  issue_4$Response(params?: {
    tripId?: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.Issue_4Path, 'post');
    if (params) {
      rb.query('tripId', params.tripId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `issue_4$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  issue_4(params?: {
    tripId?: string;
  }): Observable<void> {

    return this.issue_4$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation confirm_2
   */
  static readonly Confirm_2Path = '/api/services/app/Trip/Confirm';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `confirm_2()` instead.
   *
   * This method doesn't expect any request body.
   */
  confirm_2$Response(params?: {
    tripId?: string;
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.Confirm_2Path, 'post');
    if (params) {
      rb.query('tripId', params.tripId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `confirm_2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  confirm_2(params?: {
    tripId?: string;
  }): Observable<TripDto> {

    return this.confirm_2$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * Path part for operation addLog_1
   */
  static readonly AddLog_1Path = '/api/services/app/Trip/AddLog';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addLog_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  addLog_1$Response(params?: {
    tripId?: string;
    description?: string;
  }): Observable<StrictHttpResponse<Array<LogDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.AddLog_1Path, 'post');
    if (params) {
      rb.query('tripId', params.tripId, {});
      rb.query('description', params.description, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<LogDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `addLog_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  addLog_1(params?: {
    tripId?: string;
    description?: string;
  }): Observable<Array<LogDto>> {

    return this.addLog_1$Response(params).pipe(
      map((r: StrictHttpResponse<Array<LogDto>>) => r.body as Array<LogDto>)
    );
  }

  /**
   * Path part for operation changeStatus_1
   */
  static readonly ChangeStatus_1Path = '/api/services/app/Trip/ChangeStatus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changeStatus_1()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  changeStatus_1$Response(params?: {
    tripId?: string;
    body?: TripStatusDto
  }): Observable<StrictHttpResponse<Array<LogDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.ChangeStatus_1Path, 'post');
    if (params) {
      rb.query('tripId', params.tripId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<LogDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `changeStatus_1$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  changeStatus_1(params?: {
    tripId?: string;
    body?: TripStatusDto
  }): Observable<Array<LogDto>> {

    return this.changeStatus_1$Response(params).pipe(
      map((r: StrictHttpResponse<Array<LogDto>>) => r.body as Array<LogDto>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changeStatus_1$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  changeStatus_1$Xml$Response(params?: {
    tripId?: string;
    body?: TripStatusDto
  }): Observable<StrictHttpResponse<Array<LogDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.ChangeStatus_1Path, 'post');
    if (params) {
      rb.query('tripId', params.tripId, {});
      rb.body(params.body, 'application/*+xml');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<LogDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `changeStatus_1$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  changeStatus_1$Xml(params?: {
    tripId?: string;
    body?: TripStatusDto
  }): Observable<Array<LogDto>> {

    return this.changeStatus_1$Xml$Response(params).pipe(
      map((r: StrictHttpResponse<Array<LogDto>>) => r.body as Array<LogDto>)
    );
  }

  /**
   * Path part for operation getApprovalProcessFlow
   */
  static readonly GetApprovalProcessFlowPath = '/api/services/app/Trip/GetApprovalProcessFlow';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApprovalProcessFlow()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApprovalProcessFlow$Response(params?: {
    tripId?: string;
  }): Observable<StrictHttpResponse<ApprovalProcessFlowDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.GetApprovalProcessFlowPath, 'get');
    if (params) {
      rb.query('tripId', params.tripId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ApprovalProcessFlowDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getApprovalProcessFlow$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApprovalProcessFlow(params?: {
    tripId?: string;
  }): Observable<ApprovalProcessFlowDto> {

    return this.getApprovalProcessFlow$Response(params).pipe(
      map((r: StrictHttpResponse<ApprovalProcessFlowDto>) => r.body as ApprovalProcessFlowDto)
    );
  }

  /**
   * Path part for operation setCostDivisionsCenters
   */
  static readonly SetCostDivisionsCentersPath = '/api/services/app/Trip/SetCostDivisionsCenters';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setCostDivisionsCenters()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setCostDivisionsCenters$Response(params?: {
    flowId?: string;
    processId?: string;
    body?: Array<CostDivisionElementDto>
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.SetCostDivisionsCentersPath, 'post');
    if (params) {
      rb.query('flowId', params.flowId, {});
      rb.query('processId', params.processId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `setCostDivisionsCenters$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setCostDivisionsCenters(params?: {
    flowId?: string;
    processId?: string;
    body?: Array<CostDivisionElementDto>
  }): Observable<void> {

    return this.setCostDivisionsCenters$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setCostDivisionsCenters$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  setCostDivisionsCenters$Xml$Response(params?: {
    flowId?: string;
    processId?: string;
    body?: Array<CostDivisionElementDto>
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.SetCostDivisionsCentersPath, 'post');
    if (params) {
      rb.query('flowId', params.flowId, {});
      rb.query('processId', params.processId, {});
      rb.body(params.body, 'application/*+xml');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `setCostDivisionsCenters$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  setCostDivisionsCenters$Xml(params?: {
    flowId?: string;
    processId?: string;
    body?: Array<CostDivisionElementDto>
  }): Observable<void> {

    return this.setCostDivisionsCenters$Xml$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getFieldsConfig_1
   */
  static readonly GetFieldsConfig_1Path = '/api/services/app/Trip/GetFieldsConfig';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFieldsConfig_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFieldsConfig_1$Response(params?: {
  }): Observable<StrictHttpResponse<Array<FieldConfigDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.GetFieldsConfig_1Path, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FieldConfigDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFieldsConfig_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFieldsConfig_1(params?: {
  }): Observable<Array<FieldConfigDto>> {

    return this.getFieldsConfig_1$Response(params).pipe(
      map((r: StrictHttpResponse<Array<FieldConfigDto>>) => r.body as Array<FieldConfigDto>)
    );
  }

  /**
   * Path part for operation createOrUpdateFieldConfig_1
   */
  static readonly CreateOrUpdateFieldConfig_1Path = '/api/services/app/Trip/CreateOrUpdateFieldConfig';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOrUpdateFieldConfig_1()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createOrUpdateFieldConfig_1$Response(params?: {
    body?: FieldConfigInputDto
  }): Observable<StrictHttpResponse<Array<FieldConfigDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.CreateOrUpdateFieldConfig_1Path, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FieldConfigDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createOrUpdateFieldConfig_1$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createOrUpdateFieldConfig_1(params?: {
    body?: FieldConfigInputDto
  }): Observable<Array<FieldConfigDto>> {

    return this.createOrUpdateFieldConfig_1$Response(params).pipe(
      map((r: StrictHttpResponse<Array<FieldConfigDto>>) => r.body as Array<FieldConfigDto>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOrUpdateFieldConfig_1$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  createOrUpdateFieldConfig_1$Xml$Response(params?: {
    body?: FieldConfigInputDto
  }): Observable<StrictHttpResponse<Array<FieldConfigDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.CreateOrUpdateFieldConfig_1Path, 'post');
    if (params) {
      rb.body(params.body, 'application/*+xml');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FieldConfigDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createOrUpdateFieldConfig_1$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  createOrUpdateFieldConfig_1$Xml(params?: {
    body?: FieldConfigInputDto
  }): Observable<Array<FieldConfigDto>> {

    return this.createOrUpdateFieldConfig_1$Xml$Response(params).pipe(
      map((r: StrictHttpResponse<Array<FieldConfigDto>>) => r.body as Array<FieldConfigDto>)
    );
  }

  /**
   * Path part for operation setCustomFields
   */
  static readonly SetCustomFieldsPath = '/api/services/app/Trip/SetCustomFields';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setCustomFields()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setCustomFields$Response(params?: {
    tripId?: string;
    body?: Array<CustomFieldDto>
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.SetCustomFieldsPath, 'post');
    if (params) {
      rb.query('tripId', params.tripId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `setCustomFields$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setCustomFields(params?: {
    tripId?: string;
    body?: Array<CustomFieldDto>
  }): Observable<TripDto> {

    return this.setCustomFields$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setCustomFields$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  setCustomFields$Xml$Response(params?: {
    tripId?: string;
    body?: Array<CustomFieldDto>
  }): Observable<StrictHttpResponse<TripDto>> {

    const rb = new RequestBuilder(this.rootUrl, TripService.SetCustomFieldsPath, 'post');
    if (params) {
      rb.query('tripId', params.tripId, {});
      rb.body(params.body, 'application/*+xml');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TripDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `setCustomFields$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  setCustomFields$Xml(params?: {
    tripId?: string;
    body?: Array<CustomFieldDto>
  }): Observable<TripDto> {

    return this.setCustomFields$Xml$Response(params).pipe(
      map((r: StrictHttpResponse<TripDto>) => r.body as TripDto)
    );
  }

}
